import { render } from "./Bayaran.vue?vue&type=template&id=2af6e3c9"
import script from "./Bayaran.vue?vue&type=script&lang=js"
export * from "./Bayaran.vue?vue&type=script&lang=js"

import "./Bayaran.vue?vue&type=style&index=0&id=2af6e3c9&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__